export default __webpack_public_path__ + "static/media/JE.5079ce97.ico";